module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/sales/interests/interests-create/interests-create.component.css
// module id = ./src/app/components/sales/interests/interests-create/interests-create.component.css
// module chunks = main